/**
 * Riester Modal Block Frontend Script
 * 
 * Handles opening and closing of modals
 * This script is for the frontend only and doesn't use any WordPress dependencies
 */

// Output a message to show the script is loading
//console.log('Riester Modal Block Frontend Script file loaded - version', new Date().toISOString());

// Import styles - this will be extracted to frontend.css
import './frontend.scss';

// Make sure we're not depending on any WordPress globals
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    //console.log('Riester Modal Block Frontend Script loaded');
    
    // Modal trigger buttons - updated to use .btn class
    const modalTriggers = document.querySelectorAll('.modal-block .modal-trigger button.btn');
    
    // Find all modals on the page
    const modals = document.querySelectorAll('.modal-block .modal-content');
    
    //console.log('Modal triggers found:', modalTriggers.length);
    //console.log('Modals found:', modals.length);
    
    // Add click event to each trigger
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        //console.log('Modal trigger clicked');
        
        // Get modal ID from data attribute
        const modalId = this.getAttribute('data-modal-id');
        
        // Find the closest modal content
        let targetModal = this.closest('.modal-block').querySelector('.modal-content');
        
        // If modalId is specified, try to find that specific modal
        if (modalId) {
          const customTarget = document.querySelector(`.modal-block [data-modal-id="${modalId}"]`);
          if (customTarget) {
            targetModal = customTarget.closest('.modal-block').querySelector('.modal-content');
          }
        }
        
        if (targetModal) {
          //console.log('Opening modal');
          // Get overlay settings
          const disableOverlayClose = this.getAttribute('data-disable-overlay-close') === 'true';
          const disableEscapeClose = this.getAttribute('data-disable-escape-close') === 'true';
          
          // Custom event - before open
          const beforeOpenEvent = new CustomEvent('modal:beforeOpen', { 
            detail: { modal: targetModal } 
          });
          document.dispatchEvent(beforeOpenEvent);
          
          // Show modal
          document.body.classList.add('modal-open');
          targetModal.classList.add('active');
          
          // Create modal overlay
          const overlay = document.createElement('div');
          overlay.className = 'modal-overlay';
          document.body.appendChild(overlay);
          
          // Custom event - after open
          const afterOpenEvent = new CustomEvent('modal:afterOpen', { 
            detail: { modal: targetModal } 
          });
          document.dispatchEvent(afterOpenEvent);
          
          // Close button functionality
          const closeBtn = targetModal.querySelector('.modal-close-btn');
          if (closeBtn) {
            closeBtn.addEventListener('click', closeModal);
          }
          
          // Overlay click to close (if not disabled)
          if (!disableOverlayClose) {
            overlay.addEventListener('click', closeModal);
          }
          
          // Escape key to close (if not disabled)
          if (!disableEscapeClose) {
            document.addEventListener('keydown', handleEscKey);
          }
        } else {
          // console.error('Modal target not found');
        }
      });
    });
    
    // Close modal function
    function closeModal() {
      //console.log('Closing modal');
      const activeModals = document.querySelectorAll('.modal-content.active');
      const overlay = document.querySelector('.modal-overlay');
      
      if (activeModals.length > 0) {
        // Custom event - before close
        const beforeCloseEvent = new CustomEvent('modal:beforeClose', { 
          detail: { modals: activeModals } 
        });
        document.dispatchEvent(beforeCloseEvent);
        
        // Remove active class from all modals
        activeModals.forEach(modal => {
          modal.classList.remove('active');
        });
        
        // Remove overlay
        if (overlay) {
          overlay.parentNode.removeChild(overlay);
        }
        
        // Remove body class
        document.body.classList.remove('modal-open');
        
        // Custom event - after close
        const afterCloseEvent = new CustomEvent('modal:afterClose', { 
          detail: { modals: activeModals } 
        });
        document.dispatchEvent(afterCloseEvent);
        
        // Remove escape key handler
        document.removeEventListener('keydown', handleEscKey);
      }
    }
    
    // Handle Escape key
    function handleEscKey(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    }
  });
})(); 